import React from "react";

// Route-level code splitting (2026-09-24): every page is its own chunk so a
// visitor to a public page no longer downloads the whole owner panel, charts
// and the other product's pages before anything renders. The fallback is an
// empty block on purpose (no spinner flash for a chunk that arrives in a few
// milliseconds on a warm connection).
export default function RouteFallback() {
  return <div aria-busy="true" style={{ minHeight: "60vh" }} />;
}
